import commonConstant from '../../common/_commonConstant';

export const errorMessage = (state, action) => {
  switch (action.type) {
    case commonConstant.SHOW_ERROR_MESSAGE:
      return Object.assign({}, state, { ...action });
    case commonConstant.HIDE_ERROR_MESSAGE:
      return Object.assign({}, state, { ...action });
    default:
      return state ? state : {};
  }
};
